import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyPermissionsExportPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PermissionsExportPage" */ '../src/PermissionsExport/PermissionsExportPage.tsx'
			)
		).PermissionsExportPage,
});
